var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showAlert)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({},on),[_c('v-fa-icon',_vm._b({attrs:{"color":"warning","icon":"exclamation-triangle"}},'v-fa-icon',_vm.$attrs,false))],1)]}}],null,false,4196451125)},[_c('span',{domProps:{"textContent":_vm._s(_vm.$t('common.oldInformations'))}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }